/* eslint-disable import/prefer-default-export */
import { UseQueryOptions } from "@tanstack/react-query";
import { getQuickRequestDetails } from "api/services/quickRequest";
import { useCustomQuery } from "hooks/useCustomQuery";
import { quickRequestQueryKeys } from "./quickRequestQueryKeys";

export const useGetQuickRequestDetails = (qrNumber: string, options: UseQueryOptions) =>
  useCustomQuery({
    queryKey: quickRequestQueryKeys.quickRequestDetails(qrNumber),
    queryFn: () => getQuickRequestDetails(qrNumber).then((res) => res.data),
    ...options,
  });
